import { createContext, use, useEffect, useState, type ReactNode } from "react";
import { useLocation } from "react-router";

export type BreadcrumbRegistry = Map<string, string>;

export const BreadcrumbContext = createContext<BreadcrumbRegistry | null>(null);

type BreadcrumbProviderProps = {
  children: ReactNode;
};

export function BreadcrumbProvider({ children }: BreadcrumbProviderProps) {
  const [registry] = useState<BreadcrumbRegistry>(() => new Map());

  return <BreadcrumbContext value={registry}>{children}</BreadcrumbContext>;
}

export function useBreadcrumb(label?: string | null) {
  const registry = use(BreadcrumbContext);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!registry) return;

    if (!label) {
      registry.delete(pathname);
      return;
    }

    registry.set(pathname, label);

    return () => {
      registry.delete(pathname);
    };
  }, [label, pathname, registry]);
}
